import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

customerCardStyles.selectButton = {
    variant: "secondary",
    hoverMode: "none",
    css: css`
        background: ${getColor("primary.contrast")};
        color: ${getColor("text.accent")};
        border: 2px solid ${getColor("text.accent")};
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:disabled {
            background: ${getColor("primary.contrast")} !important;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            opacity: 0.5;
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
    `,
};

customerCardStyles.editLink = mergeToNew(customerCardStyles.editLink, {
    css: css`
        color: ${getColor("text.accent")};
        margin-top: 1rem;
    `,
});

customerCardStyles.container = {
    css: css`
        padding: 1rem 0;
        border-bottom: 1px solid ${getColor("common.border")};
    `,
}
